<template>
  <v-app>
    <app-snackbar
    :text = "snackBarText"
    :show.sync = "snackbar"
    :color = "snackbarColor"
    :timeOut = "timeOut"
    ></app-snackbar>
    <coming-soon-modal :dialog.sync="dialog"></coming-soon-modal>
    <v-container class="signin">
      <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <v-container>
            <p class="text-title">Ingresá con tus datos de acceso</p>
            <form @submit.prevent="onSignin">
              <v-layout row>
                <v-text-field class="input-email"
                  prepend-inner-icon="mail"
                  name="email"
                  label="Email"
                  id="email"
                  v-model="email"
                  type="email"
                  color="#0098E1"
                  :rules="$ponceConfig.emailRules"
                  required></v-text-field>
              </v-layout>
              <v-layout row>
                <v-text-field class="input-password"
                  prepend-inner-icon="lock"
                  name="password"
                  label="Contraseña"
                  id="password"
                  v-model="password"
                  type="password"
                  color="#0098E1"
                  :rules="$ponceConfig.passwordRules"
                  required></v-text-field>
              </v-layout>
              <div class="text-xs-center div-reset-password">
                <a @click="comingsoon" class="text-reset-password"><u>¿Olvidaste tu contraseña?</u></a>
              </div>
              <v-layout row style="padding-top:30px">
                <v-flex xs12>
                  <div class="text-xs-center">
                    <v-btn style="text-transform:none; font-family: Source Sans Pro; font-style: normal; font-weight: 550; font-size: 16px;line-height: 20px;"
                    block color="info" type="submit">
                    Ingresar</v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </form>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
  import { SIGNIN_USER_MUTATION } from '../../constants/graphql';
  export default {
    data () {
      return {
        dialog: false,
        email: '',
        password: '',
        snackbar: false,
        snackBarText: '',
        snackbarColor: '',
        timeOut: 5000
      };
    },
    computed: {
      user () {
        return this.$store.getters.user;
      }
    },
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/equipments');
        }
      }
    },
    methods: {
      comingsoon () {
        this.dialog = true;
      },
      onSignin () {
        if (!this.$store.getters.isOnline) {
          this.snackbar = true;
          this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
          this.snackbarColor = 'red';
          return;
        }
        this.showError = false;
        const { email, password } = this.$data;
        this.$apollo.mutate({
          mutation: SIGNIN_USER_MUTATION,
          variables: {
            identity: email,
            secret: password
          }
        }).then((result) => {
          const id = result.data.authenticate.item.id;
          const token = result.data.authenticate.token;
          this.saveUserData(id, email, token);
          this.$router.push({name: 'Equipments'});
        }).catch(() => {
          this.snackbar = true;
          this.snackBarText = 'Contraseña o usuario incorrecto';
          this.snackbarColor = 'red';
        });
      },
      saveUserData (id, email, token) {
        localStorage.setItem('auth_token', token);
        this.$root.$data.userId = id;
        this.$store.dispatch('signUserIn', { id, email, token });
      },
      onResetPassword () {
        if (this.email === '') {
          return this.$store.dispatch('setError', {message: 'Email no puede estar vacío'});
        }
        this.$store.dispatch('resetPasswordWithEmail', {email: this.email});
      }
    }
  };
</script>



// WEBPACK FOOTER //
// Signin.vue?7faf6747